/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiPageResponseDailyTripHistoryDailyTripSummary } from '../models/ApiPageResponseDailyTripHistoryDailyTripSummary';
import type { ApiResponseGetEvDriveStatsResponse } from '../models/ApiResponseGetEvDriveStatsResponse';
import type { ApiResponseGetMainTripResponse } from '../models/ApiResponseGetMainTripResponse';
import type { ApiResponseGetMonthlyDriveStatsResponse } from '../models/ApiResponseGetMonthlyDriveStatsResponse';
import type { ApiResponseGetRecentEvDriveStatsResponse } from '../models/ApiResponseGetRecentEvDriveStatsResponse';
import type { ApiResponseGetRecentTripResponse } from '../models/ApiResponseGetRecentTripResponse';
import type { ApiResponseGetTripDaysResponse } from '../models/ApiResponseGetTripDaysResponse';
import type { ApiResponseGetTripDetailResponse } from '../models/ApiResponseGetTripDetailResponse';
import type { ApiResponseGetTripPathResponse } from '../models/ApiResponseGetTripPathResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DriveHistoryService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 최근 주행 이력 조회
   * 차량의 가장 최근 주행 기록을 조회합니다.
   * @returns ApiResponseGetRecentTripResponse OK
   * @throws ApiError
   */
  public getRecentTrip({
    authorization,
    vin,
    ccId,
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
  }): CancelablePromise<ApiResponseGetRecentTripResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/recent',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
      },
    });
  }
  /**
   * 최근 주행 이력 조회
   * 차량의 가장 최근 주행 기록을 조회합니다.
   * @returns ApiResponseGetRecentTripResponse OK
   * @throws ApiError
   */
  public getRecentTrip1({
    authorization,
    vin,
    ccId,
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
  }): CancelablePromise<ApiResponseGetRecentTripResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/recent/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
      },
    });
  }
  /**
   * 주행 경로 조회
   * 주행 경로 정보를 조회합니다
   * @returns ApiResponseGetTripPathResponse OK
   * @throws ApiError
   */
  public getTripPath({
    authorization,
    vin,
    ignOnTime,
  }: {
    authorization?: string,
    vin: string,
    ignOnTime: string,
  }): CancelablePromise<ApiResponseGetTripPathResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/path',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ignOnTime': ignOnTime,
      },
    });
  }
  /**
   * 주행 경로 조회
   * 주행 경로 정보를 조회합니다
   * @returns ApiResponseGetTripPathResponse OK
   * @throws ApiError
   */
  public getTripPath1({
    authorization,
    vin,
    ignOnTime,
  }: {
    authorization?: string,
    vin: string,
    ignOnTime: string,
  }): CancelablePromise<ApiResponseGetTripPathResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/path/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ignOnTime': ignOnTime,
      },
    });
  }
  /**
   * 주행 이력 상세 조회
   * 주행 상세 정보를 조회합니다
   * @returns ApiResponseGetTripDetailResponse OK
   * @throws ApiError
   */
  public getTripDetail({
    authorization,
    vin,
    ignOnTime,
  }: {
    authorization?: string,
    vin: string,
    ignOnTime: string,
  }): CancelablePromise<ApiResponseGetTripDetailResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/detail',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ignOnTime': ignOnTime,
      },
    });
  }
  /**
   * 주행 이력 상세 조회
   * 주행 상세 정보를 조회합니다
   * @returns ApiResponseGetTripDetailResponse OK
   * @throws ApiError
   */
  public getTripDetail1({
    authorization,
    vin,
    ignOnTime,
  }: {
    authorization?: string,
    vin: string,
    ignOnTime: string,
  }): CancelablePromise<ApiResponseGetTripDetailResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/detail/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ignOnTime': ignOnTime,
      },
    });
  }
  /**
   * 월별 주행 날짜 조회
   * 주행 이력이 있는 날짜 목록을 조회합니다.
   * @returns ApiResponseGetTripDaysResponse OK
   * @throws ApiError
   */
  public getTripDays({
    authorization,
    vin,
    ccId,
    month = '202510',
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
    month?: string,
  }): CancelablePromise<ApiResponseGetTripDaysResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/days/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
        'month': month,
      },
    });
  }
  /**
   * 월별 주행 날짜 조회
   * 주행 이력이 있는 날짜 목록을 조회합니다.
   * @returns ApiResponseGetTripDaysResponse OK
   * @throws ApiError
   */
  public getTripDays1({
    authorization,
    vin,
    ccId,
    month = '202510',
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
    month?: string,
  }): CancelablePromise<ApiResponseGetTripDaysResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/days',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
        'month': month,
      },
    });
  }
  /**
   * 주행 이력 조회
   * 특정 날짜의 주행 이력을 조회합니다.
   * @returns ApiPageResponseDailyTripHistoryDailyTripSummary OK
   * @throws ApiError
   */
  public getTripHistoryByDate({
    authorization,
    vin,
    ccId,
    date = '20251002',
    page = 1,
    size = 3,
    orderBy = 'DESC',
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
    date?: string,
    page?: number,
    size?: number,
    orderBy?: 'ASC' | 'DESC',
  }): CancelablePromise<ApiPageResponseDailyTripHistoryDailyTripSummary> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
        'date': date,
        'page': page,
        'size': size,
        'orderBy': orderBy,
      },
    });
  }
  /**
   * 주행 이력 삭제
   * 특정 주행 이력을 삭제합니다.
   * @returns any OK
   * @throws ApiError
   */
  public deleteTripHistory({
    authorization,
    vin,
    ignOnTime,
  }: {
    authorization?: string,
    vin: string,
    ignOnTime: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/drive-history/trip',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ignOnTime': ignOnTime,
      },
    });
  }
  /**
   * 주행 이력 조회
   * 특정 날짜의 주행 이력을 조회합니다.
   * @returns ApiPageResponseDailyTripHistoryDailyTripSummary OK
   * @throws ApiError
   */
  public getTripHistoryByDate1({
    authorization,
    vin,
    ccId,
    date = '20251002',
    page = 1,
    size = 3,
    orderBy = 'DESC',
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
    date?: string,
    page?: number,
    size?: number,
    orderBy?: 'ASC' | 'DESC',
  }): CancelablePromise<ApiPageResponseDailyTripHistoryDailyTripSummary> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
        'date': date,
        'page': page,
        'size': size,
        'orderBy': orderBy,
      },
    });
  }
  /**
   * 주행 이력 삭제
   * 특정 주행 이력을 삭제합니다.
   * @returns any OK
   * @throws ApiError
   */
  public deleteTripHistory1({
    authorization,
    vin,
    ignOnTime,
  }: {
    authorization?: string,
    vin: string,
    ignOnTime: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/drive-history/trip/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ignOnTime': ignOnTime,
      },
    });
  }
  /**
   * 월별 주행 기록 조회
   * 차량의 월별 주행 기록을 조회합니다.
   * @returns ApiResponseGetMonthlyDriveStatsResponse OK
   * @throws ApiError
   */
  public getMonthlyDriveStats({
    authorization,
    vin,
    ccId,
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
  }): CancelablePromise<ApiResponseGetMonthlyDriveStatsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/monthly-stats/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
      },
    });
  }
  /**
   * 월별 주행 기록 조회
   * 차량의 월별 주행 기록을 조회합니다.
   * @returns ApiResponseGetMonthlyDriveStatsResponse OK
   * @throws ApiError
   */
  public getMonthlyDriveStats1({
    authorization,
    vin,
    ccId,
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
  }): CancelablePromise<ApiResponseGetMonthlyDriveStatsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/monthly-stats',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
      },
    });
  }
  /**
   * 주요주행(위험/안전 Top6) 조회
   * 주요주행(위험/안전 Top6) 정보를 조회 합니다.
   * @returns ApiResponseGetMainTripResponse OK
   * @throws ApiError
   */
  public getMainTrip({
    vin,
    isSafe = false,
    page = 1,
    size = 3,
  }: {
    vin: string,
    isSafe?: boolean,
    page?: number,
    size?: number,
  }): CancelablePromise<ApiResponseGetMainTripResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/main-trip',
      query: {
        'vin': vin,
        'isSafe': isSafe,
        'page': page,
        'size': size,
      },
    });
  }
  /**
   * 주요주행(위험/안전 Top6) 조회
   * 주요주행(위험/안전 Top6) 정보를 조회 합니다.
   * @returns ApiResponseGetMainTripResponse OK
   * @throws ApiError
   */
  public getMainTrip1({
    vin,
    isSafe = false,
    page = 1,
    size = 3,
  }: {
    vin: string,
    isSafe?: boolean,
    page?: number,
    size?: number,
  }): CancelablePromise<ApiResponseGetMainTripResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/main-trip/',
      query: {
        'vin': vin,
        'isSafe': isSafe,
        'page': page,
        'size': size,
      },
    });
  }
  /**
   * 최근 EV 에너지 사용 정보 조회
   * 최근 EV 에너지 사용 정보를 조회합니다. 최근 데이터는 조회 전일 기준입니다.
   * @returns ApiResponseGetRecentEvDriveStatsResponse OK
   * @throws ApiError
   */
  public getRecentEvDriveStats({
    authorization,
    vin,
    ccId,
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
  }): CancelablePromise<ApiResponseGetRecentEvDriveStatsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/ev-stats/recent/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
      },
    });
  }
  /**
   * 최근 EV 에너지 사용 정보 조회
   * 최근 EV 에너지 사용 정보를 조회합니다. 최근 데이터는 조회 전일 기준입니다.
   * @returns ApiResponseGetRecentEvDriveStatsResponse OK
   * @throws ApiError
   */
  public getRecentEvDriveStats1({
    authorization,
    vin,
    ccId,
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
  }): CancelablePromise<ApiResponseGetRecentEvDriveStatsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/ev-stats/recent',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
      },
    });
  }
  /**
   * EV 에너지 사용 정보 조회
   * EV4,PHEV4 차량의 최근 30일 기준 EV 에너지 사용 정보를 조회합니다. 최근 데이터는 조회 전일 기준입니다.
   * @returns ApiResponseGetEvDriveStatsResponse OK
   * @throws ApiError
   */
  public getMonthlyEvDriveStats({
    authorization,
    vin,
    ccId,
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
  }): CancelablePromise<ApiResponseGetEvDriveStatsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/ev-stats/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
      },
    });
  }
  /**
   * EV 에너지 사용 정보 조회
   * EV4,PHEV4 차량의 최근 30일 기준 EV 에너지 사용 정보를 조회합니다. 최근 데이터는 조회 전일 기준입니다.
   * @returns ApiResponseGetEvDriveStatsResponse OK
   * @throws ApiError
   */
  public getMonthlyEvDriveStats1({
    authorization,
    vin,
    ccId,
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
  }): CancelablePromise<ApiResponseGetEvDriveStatsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/ev-stats',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
      },
    });
  }
}
